import dayjs from "dayjs";
import { type FC } from "react";

import { DATE_FORMAT_DMY, formatDatetime } from "@ryde/shared";

import { StationTimeEditFieldStyled } from "../../../station-time-edit";
import { FramerTooltip } from "../../../tooltips";
import { useRideStationTimeEdit } from "./use-ride-station-time-edit";

export const RideStationTimeEdit: FC = () => {
  const {
    value,
    error,
    timeFormat,
    timezone,
    handleTimeInputChange,
    onBlur,
    onKeyDown,
  } = useRideStationTimeEdit();

  const formattedValue = formatDatetime({
    dateTimeISO: value,
    dateFormat: DATE_FORMAT_DMY,
    timeFormat,
    timezone,
  });

  return (
    <>
      <FramerTooltip content={formattedValue}>
        <StationTimeEditFieldStyled
          onChange={handleTimeInputChange}
          onBlur={onBlur}
          value={dayjs.utc(value)}
          format={timeFormat}
          onKeyDown={onKeyDown}
          timezone={timezone}
          slotProps={{
            textField: {
              error: error !== null,
            },
          }}
        />
      </FramerTooltip>
      {/* Remark: Add back when we add date editing to stations, hasOverlappingDates get from useRideStationTimeEdit */}
      {/* <StationDateTimeEditFieldStyled
        className={clsx({ has_overlap: hasOverlappingDates })}
        onChange={handleTimeInputChange}
        onBlur={onBlur}
        value={dayjs.utc(value)}
        format={DATE_MM_DD_FORMAT_WITH_TIME}
        onKeyDown={onKeyDown}
        timezone={timezone}
        slotProps={{
          textField: {
            error: error !== null,
          },
        }}
      /> */}
    </>
  );
};
